import React from "react";
import { Link } from "react-router-dom";
import TitlePanel from "../titles_page/title_panel/TitlePanel";

import "./SubtitlesPage.css"

var arithemtic_geometric_inequality_formula = "$(sum_(k=0)^n a_k)/n ge (root(n)(prod_(k=0)^n a_k))$";
var cauchy_schwarz_inequality_formula = "$(sum_(k=0)^n a_k)/n ge (root(n)(prod_(k=0)^n a_k))$";
var chebyshev_inequality_formula = "$(sum_(k=0)^n a_k)/n ge (root(n)(prod_(k=0)^n a_k))$";
var rearrangement_inequality_formula = "$(sum_(k=0)^n a_k)/n ge (root(n)(prod_(k=0)^n a_k))$";
var jensen_inequality_formula = "$(sum_(k=0)^n a_k)/n ge (root(n)(prod_(k=0)^n a_k))$";
var holder_inequality_formula = "$(sum_(k=0)^n a_k)/n ge (root(n)(prod_(k=0)^n a_k))$";

const SubtitlesPageAdvancedInequalities = () => {
    return (
        <div className="titles-page-div">
            <div className="choose-topic-div">
                <h2>Choose a topic</h2>
            </div>
            <div className="titles-container">
                <Link to="/advanced/inequalities/arithemtic_geometric_inequality" style={{ textDecoration: 'none' }}>
                    <TitlePanel title="Arithmetic Geometiric Inequality" formula={arithemtic_geometric_inequality_formula}/>
                </Link>

                <Link to="/advanced/inequalities/cauchy_schwarz_inequality" style={{ textDecoration: 'none' }}>
                    <TitlePanel title="Cauchy Schwarz Inequality" formula={cauchy_schwarz_inequality_formula}/>
                </Link>

                <Link to="/advanced/inequalities/chebyshev_inequality" style={{ textDecoration: 'none' }}>
                    <TitlePanel title="Chebyshev Inequality" formula={chebyshev_inequality_formula}/>
                </Link>

                <Link to="/advanced/inequalities/rearrangement_inequality" style={{ textDecoration: 'none' }}>
                    <TitlePanel title="Rearrangement Inequality" formula={rearrangement_inequality_formula}/>
                </Link>

                <Link to="/advanced/inequalities/jensen_inequality" style={{ textDecoration: 'none' }}>
                    <TitlePanel title="Jensen Inequality" formula={jensen_inequality_formula}/>
                </Link>

                <Link to="/advanced/inequalities/holder_inequality" style={{ textDecoration: 'none' }}>
                    <TitlePanel title="Holder Inequality" formula={holder_inequality_formula}/>
                </Link>
            </div>
        </div> 
    );
}

export default SubtitlesPageAdvancedInequalities;